import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { FixUrlPipe } from 'src/app/pipes/fix-url.pipe';
import { PictureService } from 'src/app/services/picture-service.service';
@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
})
export class PictureComponent implements OnInit {
  @Input() loop: any = undefined;
  @Input() img: any = undefined;
  @Input() type: string = undefined;
  @Input() class: string = undefined;
  @Input() thumb: boolean = undefined;
  @Input() isSensible: boolean = false;
  @Input() tryThumb: boolean = false;
  @Input() alt: string = undefined;

  public disableSensitivity: boolean = false;
  public video = '/assets/icons/video.png';
  private subscription: Subscription;

  constructor(
    private fixUrl: FixUrlPipe,
    @Inject(PLATFORM_ID) private platformId: any,
    private pictureService: PictureService
  ) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }

    this.canShowImage();
    this.subscription = this.pictureService.imageClicked$.subscribe(
      (imageName) => {
        this.canShowImage();
      }
    );
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.subscription.unsubscribe();
    }
  }

  changeToJpg(imgThumb, file) {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    if (this.tryThumb) this.thumb = false;
    const transformed = this.fixUrl.transform(
      file,
      this.type,
      false,
      false,
      false,
      this.thumb
    );
    imgThumb.src = transformed;
  }
  toggleSensitivity() {
    this.disableSensitivity = !this.disableSensitivity;
    let imageName = this.img?.file;
    if (this.disableSensitivity) {
      const allowedStorage = sessionStorage.getItem('allowed');
      if (!allowedStorage) {
        sessionStorage.setItem('allowed', `${imageName},`);
        this.pictureService.emitImageClicked(imageName);
      } else if (
        allowedStorage &&
        !allowedStorage.split(',').includes(imageName)
      ) {
        sessionStorage.setItem('allowed', `${allowedStorage},${imageName}`);
        this.pictureService.emitImageClicked(imageName);
      }
    } else {
      sessionStorage.removeItem('allowed');
    }
  }
  canShowImage() {
    let imageName = this.img?.file;
    let allowedImage = sessionStorage.getItem('allowed');
    if (allowedImage && allowedImage.split(',').includes(imageName)) {
      this.disableSensitivity = true;
    } else {
      this.disableSensitivity = false;
    }
  }
}
